module.exports = __webpack_public_path__ + "static/media/transactions_active.e4ddaa70.png";